import { render, staticRenderFns } from "./sysparlayPanel.vue?vue&type=template&id=4252cde5&lang=pug&"
import script from "./sysparlayPanel.vue?vue&type=script&lang=js&"
export * from "./sysparlayPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports